import React from 'react'
import SocialMedias from './SocialMedias'
import FooterLinks from './FooterLinks'
import StandardFooter from './StandardFooter'
import SupportBlock from './SupportBlock'

const Footer = () => {
  return (
    <>
      <SupportBlock />
      <footer className="footer">
        <SocialMedias />
        <FooterLinks />
        <StandardFooter />
      </footer>
    </>
  )
}

export default Footer
